<template>
    <PrimeButton :class="`custom-text-button flex align-items-center justify-content-center`"
                 :disabled="disabled">
        <label v-if="label" for="custom-button" class="cursor-pointer">
            {{ label }}
        </label>
    </PrimeButton>
</template>

<script>
    import PrimeButton from "primevue/button";

    export default {
        name: "CustomTextButton",

        props: {
            label: {
                type: String,
                default: "",
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            error: {
                type: Boolean,
                default: false,
            },
            secondary: {
                type: Boolean,
                default: false,
            },
        },

        components: {
            PrimeButton,
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/theme/mytheme/variables";
    .custom-text-button {
        height: 18px;
        background: none;
        border: none;
        border-bottom: 2px solid var(--text-color);
        padding: 0.75rem 0.25rem;
        border-radius: 0;
        label {
            color: var(--text-color);
            text-transform: uppercase;
            font-weight: 600;
        }
        &.p-button:hover, &.p-button:active {
            background: none;
            border: none;
            border-bottom: 2px solid var(--text-color);
        }
        &:hover {
            opacity: 0.6;
        }
    }
</style>
